import moment from 'moment';
import I18njs from 'i18n-js';

import { store } from '../redux/store';
import { getDayName } from './time';
import { FIFTEEN_DAYS, ONE_DAY } from '../constants/date';
import { timesheetStartsFirstDayOfMonth, timesheetStartsMidOfMonth } from './date';

class TimesheetStartDayValidator {
  weekStart = () => store.getState().company.data.weekStart - 1;
  validate = (value) => {
    const timesheetDuration = store.getState().company.data.timesheetDuration;
    if (timesheetDuration === ONE_DAY) return true;
    if (timesheetDuration === FIFTEEN_DAYS) {
      return timesheetStartsFirstDayOfMonth(value) || timesheetStartsMidOfMonth(value);
    } else {
      return moment(value).day() === this.weekStart();
    }
  };
  message = () => {
    if (store.getState().company.data.timesheetDuration === FIFTEEN_DAYS) {
      return I18njs.t('timesheets.InvalidTimesheetStartDateStartOrMidOfMonth');
    } else {
      return I18njs.t('timesheets.InvalidTimesheetStartDate', { day: getDayName(this.weekStart()) });
    }
  };
}

const checkPasswordComplexity = (pwd) => {
  const hasUpperCase = /[A-Z]/.test(pwd);
  const hasLowerCase = /[a-z]/.test(pwd);
  const hasNumbers = /\d/.test(pwd);
  const hasNonalphas = /\W/.test(pwd);
  return pwd.length > 7 && hasLowerCase && hasNonalphas && hasNumbers && hasUpperCase;
};

class phoneNumberValidator {
  // https://github.com/twilio/authy-form-helpers/blob/master/src/form.authy.js
  validate = (value) => {
    return value !== '' && value.match(/^([0-9][0-9][0-9])\W*([0-9][0-9]{2})\W*([0-9]{0,5})$/);
  };
  message = () => {
    return I18njs.t('settings.security.Invalidphonenumber');
  };
}

export { phoneNumberValidator, checkPasswordComplexity, TimesheetStartDayValidator };
